import { render } from "./DataBoxes.vue?vue&type=template&id=49b0b632"
import script from "./DataBoxes.vue?vue&type=script&lang=ts"
export * from "./DataBoxes.vue?vue&type=script&lang=ts"

import "./DataBoxes.vue?vue&type=style&index=0&id=49b0b632&lang=scss"
script.render = render

export default script